import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { CookiesAllowedActions, selectCookiesPoliceModalVisible } from '../../store/cookies-allowed';

@Component({
  selector: 'pub-cookies-policy-modal',
  styleUrls: ['./cookies-policy-modal.component.scss'],
  templateUrl: './cookies-policy-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookiesPolicyModalComponent implements AfterViewInit {
  @ViewChild('cookiesPolicyModalTemplate', { static: false }) cookiesPolicyModalTemplate?: TemplateRef<never>;
  policyModalVisible$ = this.store.select(selectCookiesPoliceModalVisible);

  constructor(private store: Store) {}

  ngAfterViewInit(): void {
    this.initCheckCookiesPoliceModal();
  }

  public setStatusCookiesPolicy(isAllowedCookies: boolean): void {
    this.store.dispatch(CookiesAllowedActions.updateState({ isAllowedCookies }));
  }

  private initCheckCookiesPoliceModal(): void {
    this.store.dispatch(CookiesAllowedActions.load());
  }
}
